// Add future public-site languages here. Sanity content already resolves any
// matching language code; each new language also needs translations for the
// site's static interface in translations.js and an optional flag asset.
export const LANGUAGES = [
  {code: "en", label: "English", flag: "/images/USA-flag.png"},
  {code: "es", label: "Español", flag: "/images/Mexico-flag.jpg"},
];

export const SUPPORTED_LANGUAGE_CODES = LANGUAGES.map(({code}) => code);
